import React from 'react';
import { Camera, Maximize2 } from 'lucide-react';
interface LiveFeedProps {
  isScanning: boolean;
  scanStage?: string;
}
export function LiveFeed({
  isScanning,
  scanStage
}: LiveFeedProps) {
  return <div className="relative w-full aspect-video bg-black rounded-card overflow-hidden border-2 border-border shadow-xl" data-id="element-192">
      {/* Camera Feed Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-surface to-surface-2 flex items-center justify-center" data-id="element-193">
        <div className="text-text-secondary flex flex-col items-center opacity-40" data-id="element-194">
          <Camera className="w-20 h-20 mb-4" data-id="element-195" />
          <span className="text-sm font-mono" data-id="element-196">CAMERA: TRAY-01</span>
        </div>
      </div>

      {/* Scanning Animation */}
      {isScanning && <>
          <div className="absolute top-0 left-0 w-full h-1 bg-info shadow-[0_0_20px_rgba(59,130,246,0.8)] animate-[scan_2s_ease-in-out_infinite]" data-id="element-197" />
          <div className="absolute inset-0 bg-info/5" data-id="element-198" />

          {/* Simulated Detection Boxes */}
          <div className="absolute top-[20%] left-[25%] w-28 h-28 border-2 border-success/60 rounded-lg animate-pulse" data-id="element-199">
            <span className="absolute -top-6 left-0 bg-success text-white text-xs px-2 py-0.5 font-bold rounded" data-id="element-200">
              Scalpel
            </span>
          </div>
          <div className="absolute bottom-[30%] right-[30%] w-32 h-20 border-2 border-success/60 rounded-lg animate-pulse" style={{
        animationDelay: '0.3s'
      }} data-id="element-201">
            <span className="absolute -top-6 left-0 bg-success text-white text-xs px-2 py-0.5 font-bold rounded" data-id="element-202">
              Forceps
            </span>
          </div>
          <div className="absolute top-[50%] right-[20%] w-24 h-24 border-2 border-success/60 rounded-lg animate-pulse" style={{
        animationDelay: '0.6s'
      }} data-id="element-203">
            <span className="absolute -top-6 left-0 bg-success text-white text-xs px-2 py-0.5 font-bold rounded" data-id="element-204">
              Clamp
            </span>
          </div>

          {/* Scan Stage Indicator */}
          {scanStage && <div className="absolute bottom-4 left-4 bg-black/80 px-4 py-2 rounded-input backdrop-blur-sm border border-info/30" data-id="element-205">
              <span className="text-info font-medium text-sm" data-id="element-206">{scanStage}</span>
            </div>}
        </>}

      {/* Camera Status Indicator */}
      <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/60 px-3 py-2 rounded-input backdrop-blur-sm" data-id="element-207">
        <div className="w-2.5 h-2.5 bg-critical rounded-full animate-pulse" data-id="element-208" />
        <span className="text-critical font-mono text-xs font-bold" data-id="element-209">LIVE</span>
      </div>

      {/* Fullscreen Button */}
      <button className="absolute bottom-4 right-4 p-2.5 bg-black/60 rounded-input text-white hover:bg-black/80 transition-colors backdrop-blur-sm" data-id="element-210">
        <Maximize2 className="w-5 h-5" data-id="element-211" />
      </button>
    </div>;
}